import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import Select from "react-select";
import "react-select/dist/react-select.css";
import Loader from "../../utils/Loader";
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import ShippingAddressModal from "./ShippingAddressModal";

// State
import { getLocations, getProvinces } from "../../../store/actions/locations";
import { setShipping, setSavedShippingAddress, setActiveCheckoutSection } from "../../../store/actions/checkout";

// CSS
import "../../../css/custom-checkbox.css";
import "../../../css/shipping-form.css";

// Util
import { setCheckoutSectionActive as setCheckoutSectionActiveGA, setCheckoutSectionComplete as setCheckoutSectionCompleteGA } from "../../../utils/google-analytics";

class ShippingSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showAddressModal: false,
			fname: !!props.shipping.fname ? props.shipping.fname : "",
			lname: !!props.shipping.lname ? props.shipping.lname : "",
			company: !!props.shipping.company ? props.shipping.company : "",
			address: !!props.shipping.address ? props.shipping.address : "",
			address_2: !!props.shipping.address_2 ? props.shipping.address_2 : "",
			city: !!props.shipping.city ? props.shipping.city : "",
			postal: !!props.shipping.postal ? props.shipping.postal : "",
			country: !!props.shipping.country ? props.shipping.country : "",
			province: !!props.shipping.province ? props.shipping.province : "",
			phone_1: !!props.shipping.phone_1 ? props.shipping.phone_1 : "",
			phone_2: !!props.shipping.phone_2 ? props.shipping.phone_2 : "",
			phone_3: !!props.shipping.phone_3 ? props.shipping.phone_3 : "",
			save_address: !!props.shipping.id ? props.shipping.id : ""
		};
	}

	componentDidMount() {
		this.props.getLocations(true);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.default_country !== null && this.state.country === "") {
			this.setState({
				country: nextProps.default_country
			});
		}
	}

	updateSelectedCountry = country => {
		this.setState(
			{
				country: country.id,
				province: ""
			},
			() => this.props.getProvinces(this.state.country, true)
		);
	};

	updateSelectedProvince = province => {
		this.setState({
			province: province.abbreviation
		});
	};

	handleInputChange(event) {
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.handleSubmit();
		}
	}

	handeAddressSelect = shippingData => {
		this.setState({ showAddressModal: false });
		this.props.setSavedShippingAddress(shippingData);

		// Set current section as complete
		setCheckoutSectionCompleteGA(3);

		// Set Billing active
		setCheckoutSectionActiveGA(4);
		this.props.setActiveCheckoutSection("billing");
	};

	handleSaveChange = event => {
		this.setState({ save_address: event.target.checked });
	};

	render() {
		const { user, shipping, countries, provinces, errors, locationsError, locationsLoading } = this.props;
		// const shipping_country = 1

		return (
			<div>
				<div className="delivery-heading">
					<h2>Enter a Shipping Address:</h2>

					{!!user.customer && (
						<div>
							<div className={"btn btn--red btn--heading" + (this.props.shippingCheckInProgress ? " loading" : "")} disabled={this.props.shippingCheckInProgress} onClick={() => this.setState({ showAddressModal: true })}>
								Choose Saved Address
							</div>

							{/* ADDRESS MODAL */}
							{this.state.showAddressModal && (
								<Modal
									title={"Choose Address"}
									buttons={[
										{
											type: Button,
											text: "Close",
											action: () => this.setState({ showAddressModal: false }),
											disabled: this.props.deleteInProcess
										}
									]}
								>
									<ShippingAddressModal handleSelect={this.handeAddressSelect} />
								</Modal>
							)}
						</div>
					)}
				</div>

				<form className="shipping-form tight-form-fields">
					{!!shipping && shipping.id && <input type="hidden" name="id" value={shipping.id} />}

					<div className="floated-field-container">
						<div className="form-field no-label-field half-field">
							<label htmlFor="fname">First Name:</label>

							{!!errors.fname && <div className="error">{errors.fname}</div>}

							<input type="text" name="fname" id="fname" value={this.state.fname} placeholder="First Name" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
						</div>

						<div className="form-field no-label-field half-field">
							<label htmlFor="lname">Last Name:</label>

							{!!errors.lname && <div className="error">{errors.lname}</div>}

							<input type="text" name="lname" id="lname" value={this.state.lname} placeholder="Last Name" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
						</div>
					</div>

					<div className="form-field no-label-field">
						<label htmlFor="password">Company:</label>

						{!!errors.company && <div className="error">{errors.company}</div>}

						<input type="text" name="company" id="company" value={this.state.company} placeholder="Company" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
					</div>

					<div className="form-field no-label-field">
						<label htmlFor="password">Address:</label>

						{!!errors.address && <div className="error">{errors.address}</div>}

						<input type="text" name="address" id="address" value={this.state.address} placeholder="Address" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
					</div>
					<div className="form-field no-label-field">
						<label htmlFor="address_2">Address 2:</label>

						{!!errors.address_2 && <div className="error">{errors.address_2}</div>}

						<input type="text" name="address_2" id="address_2" value={this.state.address_2} placeholder="Address Line 2" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
					</div>

					<div className="floated-field-container">
						<div className="form-field no-label-field half-field">
							<label htmlFor="city">City:</label>

							{!!errors.city && <div className="error">{errors.city}</div>}

							<input type="text" name="city" id="city" value={this.state.city} placeholder="City" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
						</div>

						<div className="form-field no-label-field half-field">
							<label htmlFor="postal">Postal:</label>

							{!!errors.postal && <div className="error">{errors.postal}</div>}

							<input type="text" name="postal" id="postal" value={this.state.postal} placeholder="Postal" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
						</div>
					</div>

					{locationsError ? (
						<div className="error top-margin">{locationsError}</div>
					) : locationsLoading ? (
						<div className="pt2 pb2">
							<Loader />
						</div>
					) : (
						<div className="floated-field-container">
							<div className="form-field no-label-field half-field">
								<label htmlFor="country">Country:</label>

								{!!errors.country && <div className="error">{errors.country}</div>}

								<Select name={`country`} placeholder="Country" value={this.state.country} onChange={selection => this.updateSelectedCountry(selection)} clearable={false} valueKey="id" labelKey="title" options={countries} />
							</div>

							<div className="form-field no-label-field half-field">
								<label htmlFor="province">Province:</label>

								{!!errors.province && <div className="error">{errors.province}</div>}

								<Select name={`province`} placeholder={this.state.country === "CA" ? "Province" : "State"} value={this.state.province} onChange={selection => this.updateSelectedProvince(selection)} clearable={false} valueKey="abbreviation" labelKey="name" options={provinces} />
							</div>
						</div>
					)}

					<div className="floated-field-container">
						<div className="form-field no-label-field half-field">
							<label htmlFor="phone">Phone:</label>

							{!!errors.phone && <div className="error">{errors.phone}</div>}

							<input type="text" className="phone-num phone-num-1" pattern="\d*" maxLength="3" name="phone_1" id="phone_1" value={this.state.phone_1} placeholder="555" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
							<input type="text" className="phone-num phone-num-2" pattern="\d*" maxLength="3" name="phone_2" id="phone_2" value={this.state.phone_2} placeholder="555" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
							<input type="text" className="phone-num phone-num-3" pattern="\d*" maxLength="4" name="phone_3" id="phone_3" value={this.state.phone_3} placeholder="5555" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
						</div>
					</div>

					<div className="btn_container">
						{!!errors.general && <div className="error">{errors.general}</div>}

						{!!user.customer && (
							<div className="form-field half-field">
								<div className="custom-label checkbox-label no-bottom-margin">
									<input type="checkbox" id="save_address" name="save_address" value="1" checked={this.state.save_address} onChange={event => this.handleSaveChange(event)} />
									<label htmlFor="save_address">Save Address</label>
								</div>
							</div>
						)}

						<button
							className={"btn submit-btn" + (this.props.shippingCheckInProgress ? " loading" : "")}
							disabled={this.props.shippingCheckInProgress}
							onClick={e => {
								e.preventDefault();
								this.props.setShipping(this.state).then(resp => {
									if (resp !== undefined) {
										// Set current section as complete
										setCheckoutSectionCompleteGA(3);

										// Set Billing active
										setCheckoutSectionActiveGA(4);
										this.props.setActiveCheckoutSection("billing");
									}
								});
							}}
						>
							<span>Use Address</span>
						</button>
					</div>
				</form>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user,
		shipping: state.checkout.shipping,
		errors: state.checkout.shippingErrors,
		countries: state.locations.countries,
		default_country: state.locations.default_country,
		provinces: state.locations.provinces,
		locationsLoading: state.locations.isLoading,
		locationsError: state.locations.error,
		shippingCheckInProgress: state.checkout.shippingCheckInProgress
	};
};

export default connect(
	mapStateToProps,
	{ getLocations, getProvinces, setShipping, setSavedShippingAddress, setActiveCheckoutSection }
)(ShippingSection);



// WEBPACK FOOTER //
// ./src/components/checkout/shipping/ShippingSection.js